import styled from 'styled-components';

export const OrgHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  .org-name {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-text);

    a {
      color: inherit;
    }

    a:hover {
      color: var(--color-accent);
    }
  }

  .org-meta {
    color: var(--color-text-muted);
    font-size: 12px;
  }
`;
